import tinycolor from "tinycolor2"

const gray700 = "#44403c"

export function isColorLight(color: string) {
  return tinycolor(color).getBrightness() > 172
}

export function getContrastTextColor(color: string) {
  return isColorLight(color) ? gray700 : "white"
}
